import AdminRole from "./AdminRole";
import Company from "./Company";

export class AdminUserModel {
    "adminUserId": number;
    "firstName": string = "";
    "lastName": string = "";
    "logonId": string = "";
    "password": string = "";
    "adminRoles": AdminRole[] = [];
    "companies": Company[] = [];

}